import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Banknote, Building2, RefreshCcw } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { Button } from '../components/ui/button';

const loanProducts = [
  {
    icon: Banknote,
    title: 'Working Capital Loans',
    desc: 'Short-term loans to finance growth, unexpected expenses or day-to-day operations.',
    bullets: ['$10K to $500K available', '6 to 24 month terms', 'Application in minutes', 'Funded within 24-48 hours'],
  },
  {
    icon: RefreshCcw,
    title: 'Sale-Leaseback',
    desc: 'Unlock the equity in your unencumbered equipment without selling the asset.',
    bullets: ['Convert assets to working capital', 'Continue using your equipment', 'Improve balance sheet flexibility', 'Available across all sectors'],
  },
  {
    icon: Building2,
    title: 'Mortgage Refinancing',
    desc: 'Leverage commercial property assets to fuel growth and consolidate financing.',
    bullets: ['Owner-occupied or investment', 'Competitive rates', 'Cash-out refinancing', 'Up to 75% LTV available'],
  },
];

export default function BusinessLoans() {
  return (
    <>
      <PageHero
        eyebrow="Business Loans"
        title="Working capital beyond equipment"
        subtitle="Foxstone offers short-term business loans to finance growth, unexpected expenses and day-to-day operations of your business."
        image="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1920&q=80"
      />

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Beyond equipment</p>
            <h2 className="font-display text-3xl lg:text-4xl text-fx-navy font-bold mt-3">Simple applications. Fast approvals. Real capital.</h2>
            <div className="fx-section-divider mt-5" />
            <p className="mt-6 text-slate-700 leading-relaxed">
              Like our leases, we make the process as simple as possible. Submit an application with only a business card worth of information and get approved in hours. Our products are designed to deliver capital exactly when your business needs it.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-14">
            {loanProducts.map((p, i) => {
              const Icon = p.icon;
              return (
                <div key={i} className="bg-white border border-slate-200 rounded-lg p-8 fx-lift">
                  <div className="w-14 h-14 rounded-md bg-fx-cream border border-fx-gold/40 flex items-center justify-center text-fx-gold">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-2xl text-fx-navy font-bold mt-5">{p.title}</h3>
                  <p className="mt-3 text-slate-600 text-sm">{p.desc}</p>
                  <ul className="mt-5 space-y-2.5">
                    {p.bullets.map((b, idx) => (
                      <li key={idx} className="flex gap-2.5 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-fx-gold shrink-0 mt-0.5" /><span>{b}</span></li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          <div className="mt-12 text-center">
            <Button asChild className="bg-fx-navy hover:bg-fx-navy-deep text-white rounded-sm h-12 px-8">
              <Link to="/contact">Apply now <ArrowRight className="w-4 h-4 ml-2" /></Link>
            </Button>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
